export type ErrorResponse = {
  statusCode: string;
  timestamp: number;
  message: string;
};
export interface HttpResponse<T> extends Response {
  parsedBody?: T & ErrorResponse;
}

async function http<T>(request: RequestInfo): Promise<HttpResponse<T>> {
  const response: HttpResponse<T> = await fetch(request, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    }
  });
  try {
    response.parsedBody = (await response?.json?.()) || undefined;
  } catch (error) {
    response.parsedBody = undefined;
  }

  return response;
}

export async function get<T>(
  path: string,
  args: RequestInit = { method: "get" }
): Promise<HttpResponse<T & ErrorResponse>> {
  return await http<T & ErrorResponse>(new Request(path, args));
}

export async function post<T>(
  path: string,
  body: any,
  args: RequestInit = {
    method: "post",
    body: JSON.stringify(body)
  }
): Promise<HttpResponse<T & ErrorResponse>> {
  return await http<T & ErrorResponse>(new Request(path, args));
}

export async function Delete<T>(
  path: string,
  body: any,
  args: RequestInit = {
    method: "delete",
    body: JSON.stringify(body)
  }
): Promise<HttpResponse<T & ErrorResponse>> {
  return await http<T & ErrorResponse>(new Request(path, args));
}

export async function put<T>(
  path: string,
  body: any,
  args: RequestInit = { method: "put", body: JSON.stringify(body) }
): Promise<HttpResponse<T & ErrorResponse>> {
  return await http<T & ErrorResponse>(new Request(path, args));
}

export const SuccessCodeRegex = /2[0-9]{2}/;
